import * as tslib_1 from "tslib";
import { InputField } from '../input_field';
var ValueField = /** @class */ (function (_super) {
    tslib_1.__extends(ValueField, _super);
    function ValueField(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'maxValue,minValue';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
        return _this;
    }
    ValueField.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), {
            "type": "ValueField",
            "maxValue": this.maxValue,
            "minValue": this.minValue
        });
    };
    ValueField.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return ValueField;
}(InputField));
export { ValueField };
//# sourceMappingURL=value_fields.js.map